export default "__VITE_ASSET__bd79b66a__"